import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import {
	AUTH_PREFIX_PATH,
	UNAUTHENTICATED_ENTRY,
	REDIRECT_URL_KEY
} from 'configs/AppConfig'

const ProtectedRoute = () => {
	const { token } = useSelector(state => state.auth)
	const location = useLocation()

	if (!token) {
		const searchParams = new URLSearchParams(location.search);
		const shareKey = searchParams.get('share_key');

		// If URL contains share_key, redirect to public lookup instead of login
		if (shareKey && location.pathname.includes('/dashboard/lookup')) {
			return <Navigate to={`/public/lookup${location.search}`} replace />;
		}

		return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`} replace />;
	}

	return <Outlet />
}

export default ProtectedRoute